<div class="px-4 py-4 whitespace-nowrap text-center">
    <div class="text-black">Environment: <span class="font-bold">{{ data.envName }}</span></div>
    <a class="mx-auto w-full max-w-48 h-10 px-4 border border-solid border-primary text-primary cursor-pointer rounded-full flex items-center justify-center"
        [href]="data.altEnv.url">
        Go to {{ data.altEnv.name }}
    </a>
</div>